/*
*
* File JS componente Two Columns
*
*/

// IMPORT MODULES
//--------------------------------------------------------------------//

// Nulla al momento


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './two-columns.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const twoColumns = () => {}
export default twoColumns;

//--------------------------------------------------------------------//